import {http} from '@/http'

export default {
  getDistricts() {
    return http.get('/api/v1/districts')
  },
  getBasePrices(routeType) {
    return http.get('/api/v1/base-prices', {params: {route_type: routeType}})
  },
  // Tarifario reestructurado (DEF-ADM-017): agrupado por provincia.
  // cityId overridea X-City-Id para las tabs (sin cambiar la ciudad global).
  // La ciudad va en X-City-Id, que pone el interceptor con la del header.
  getBasePricesGrouped(direction) {
    return http.get('/api/v1/base-prices', {
      params: {group_by: 'province', direction}
    })
  },
  updateBasePrices(items) {
    return http.put('/api/v1/base-prices', {items})
  },
  getCalculatedPrices(routeType) {
    return http.get('/api/v1/calculated-prices', {params: {route_type: routeType}})
  }
}
